import { render, staticRenderFns } from "./wx-code.vue?vue&type=template&id=5a6130c6&scoped=true"
import script from "./wx-code.vue?vue&type=script&lang=js"
export * from "./wx-code.vue?vue&type=script&lang=js"
import style0 from "./wx-code.vue?vue&type=style&index=0&id=5a6130c6&prod&lang=less&scoped=true"
import style1 from "./wx-code.vue?vue&type=style&index=1&id=5a6130c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6130c6",
  null
  
)

export default component.exports